<template>
 <div class="warpper"> 
    <!-- <div class="tip">请选择艾糖Plus下载类型</div> -->
    <!-- <van-tabs v-model:active="tabActive" @click="change" color='#036CFC' title-active-color='#036CFC'>
     <van-tab v-for="item in tabList" :key="item.path" :name='item.path' :title="item.name"></van-tab>
    </van-tabs> -->
    <!-- 图片 -->
      <div >
      <div class="flex-center">
       <img src="@/assets/images/atPlus.png" class="item item-img" height="320" alt="">
        <div class="item item-apple flex-row-center" @click="jump('atPlus','IOS')">
         <img src="@/assets/images/apple-logo.png" width="24" height="24" class="logo" alt="logo">iPhone版本
        </div>
        <div class="item item-apple flex-row-center item-android" @click="jump('atPlus','Android')">
         <img src="@/assets/images/android-logo.png" width="24" height="24" class="logo" alt="logo">Android版本
        </div>
        <div class="item version" v-if="AndroidConfig[downloadConfig.atPlus.Android]">版本：{{AndroidConfig[downloadConfig.atPlus.Android].versionNumber}}</div>
     </div>
     <!-- content -->
     <div class="item content-item content-title">功能介绍：</div>
     <!-- <div class="item content-item content">{{!!(AndroidConfig[downloadConfig[tabActive].Android].versionUpdateContent)?(AndroidConfig[downloadConfig[tabActive].Android].versionUpdateContent):'本次版本更新聚焦于体验优化及bug修复，旨在持续优化，为用户带来更加流畅的使用体验'}}</div> -->
     <div class="item content-item content" v-if="AndroidConfig[downloadConfig.atPlus.Android]">{{(AndroidConfig[downloadConfig[tabActive].Android].versionUpdateContent)?(AndroidConfig[downloadConfig[tabActive].Android].versionUpdateContent):'本次版本更新聚焦于体验优化及bug修复，旨在持续优化，为用户带来更加流畅的使用体验'}}</div>
    </div>

    
    <!-- 幕布提示 -->
    <div class="showLoad" v-if="showLoad" @click="showLoad = false">
     <!-- <div class="first flex-row-center">
      <div class="numTag">1</div>
      <span>点击右上角的</span>
      <img src="@/assets/images/more.png" width="28" height="28" alt="">
      <span>按钮</span>
     </div> -->
     <div class="box_4 flex-col">
        <div class="box_5 flex-row">
          <div class="text-wrapper_3 flex-col">
            <span class="text_11">1</span>
          </div>
          <span class="text_12">点击右上角的</span>
          <div class="more-img">
            <img
              class="label-3"
              referrerpolicy="no-referrer"
              width="28" height="6"
              src="@/assets/images/more.png"
            />
          </div>
          <span class="text_13">按钮</span>
        </div>
        <div class="box_6 flex-row">
          <div class="text-wrapper_4 flex-col">
            <span class="text_14">1</span>
          </div>
          <span class="text_15">选择</span>
          <div class="group_4 flex-row">
            <div class="image-text_3 flex-row justify-between">
              <img
                class="thumbnail_4"
                referrerpolicy="no-referrer"
                src="@/assets/images/chrome.png"
              />
              <span class="text-group_3">在浏览器中打开</span>
            </div>
          </div>
        </div>
      </div>
    </div>
 </div>
</template>
<script setup>
import { nextTick, onMounted, reactive, ref, watch } from "vue";
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'
import {appdownload, getAllVersionInfo} from "@/request/index"
import {baseConfig} from '@/request/config'
import {isWeixin} from '@/utils/index'
const store = useStore()
const router = useRouter()
const atPng = ref('@/assets/images/at.png')
onMounted(() => {
  getList();
})
const AndroidConfig = reactive({
  'com.leto.android.bloodsugar':null,
  'com.bloodsugar.app':null,
  'com.glu.gludoctor':null
})
const getList = (e)=>{
  // 获取APP列表
  getAllVersionInfo().then(res=>{
    // console.log(res,'----------------')
    if(res.code == 200) {
      res.data.forEach(item=>{
        if(item.versionType == 2 && item.packageName) {
          console.log('----------',item.packageName);
          AndroidConfig[item.packageName] = item;
        }
      });
    }
  })
}
const tabList = [
 {name:'艾糖Plus',path:'atPlus'},
 {name:'合卫医生',path:'doctor'},
 {name:'艾糖',path:'at'}
]
const contentList=[
 []
];
const tabActive = ref('atPlus')
const showLoad = ref(false)
const downloadConfig = reactive({
  at:{
    IOS:'https://apps.apple.com/us/app/id1522838008',
    // Android:'aitang.apk'
    Android:'com.leto.android.bloodsugar'
  },
  atPlus:{
    IOS:'https://apps.apple.com/us/app/id6468896042',
    // Android:'aitangplus.app'
    Android:'com.bloodsugar.app'
  },
  doctor:{
    IOS:'https://apps.apple.com/us/app/id1530330783',
    // Android:'doctor.apk'
    Android:'com.glu.gludoctor'
  },
})
const change = (e)=>{
 console.log('000000000000',tabActive.value)
  console.log(isWeixin(),'11111111111111')
}
const jump = (type,phone)=>{
  
  // console.log(downloadConfig.value,'00000000000000',downloadConfig,'11111111111',downloadConfig.at.IOS)
  // return false;
 if(isWeixin()) {
  showLoad.value = true;
  return;
 }
 if(phone == "IOS") {
  window.location.href = downloadConfig[type][phone]
 } else {
  // 安卓直接进行APP下载
  window.location.href = baseConfig().baseURL + '/system/appUpgrade/download?packageName=' + downloadConfig[type][phone];
  // let formData = new FormData();
  // formData.append('packageName', downloadConfig[type][phone]);
  // appdownload('?packageName='+downloadConfig[type][phone]).then(res=>{
    
  // },error=>{
  //   console.log('11111111111111111')
  // }).catch(err=>{
  //   console.log('333333333333')
  // })
 }
}
</script>
<style lang="scss" scoped>
.warpper {
  width: 100vw;
  height: 100vh;
  background-color: #F2F2F2;
  overflow: scroll;
  background: #fff;
  
}

.tip{
 border-top: 1px solid #EEE;
 height: 54px;
 width: 100vw;
 padding-left:14px;
 line-height: 54px;
 font-family: PingFangSC, PingFang SC;
 font-weight: 500;
 font-size: 18px;
 color: #333333;
 // line-height: 18px;
 text-align: left;
 font-style: normal;
}
.item {
 margin-top: 18px;
}
.item-apple{
 width: 274px;
 height: 62px;
 background: #000000;
 border-radius: 4px;

 font-family: PingFangSC, PingFang SC;
 font-weight: 500;
 font-size: 24px;
 color: #FFFFFF;
 line-height: 62px;
 text-align: left;
 font-style: normal;
 vertical-align: middle;
}
.item-android{
  background: #036CFC;
}
.version{
 // width: 100px;
 width: 100%;
 height: 18px;
 font-family: PingFangSC, PingFang SC;
 font-weight: 400;
 font-size: 18px;
 color: #999999;
 line-height: 18px;
 text-align: center;
 font-style: normal;
}
.content-title{
 width: 100%;
 height: 22px;
 font-family: PingFangSC, PingFang SC;
 font-weight: 400;
 font-size: 22px;
 color: rgba(0,0,0,0.85);
 line-height: 22px;
 text-align: left;
 font-style: normal;
}
.content{
 // width: 327px;
 // height: 84px;
 width: 100%;
 line-height: 28px;
 font-family: PingFangSC, PingFang SC;
 font-weight: 400;
 font-size: 18px;
 color: rgba(102,102,102,0.85);
 line-height: 28px;
 text-align: left;
 font-style: normal;
 word-wrap: break-word;
  box-sizing: border-box;
}
.content-item{
 padding:0 24px;
 margin-bottom:7px;
}
.showLoad{
  position: fixed; /* 固定定位，覆盖整个页面 */
  top: 0;
  left: 0;
  width: 100vw; /* 视口宽度 */
  height: 100vh; /* 视口高度 */
  background-color: rgba(0, 0, 0, 0.8); /* 黑色背景，50%透明度 */
  z-index: 1000; /* 确保遮罩层在其他内容之上 */
  
}


.logo{
 margin-right: 9px;
}
.flex-center{
  display: flex;
  flex-direction: column;
  align-items: center;
}
.flex-row-center{
 display: flex;
 justify-content: center;
 align-items: center;
}



// 遮罩
.flex-col{
      box-sizing: border-box;
    background-color: rgba(3, 108, 252, 1.000000);
    border-radius: 50%;
    margin-bottom: 10.00px;
    display: flex
;
    flex-direction: column;
    padding: 5px 10px 5px 10px;
}
.flex-row{
      box-sizing: border-box;
    flex-direction: row;
    display: flex
;
}
.box_4 {
  background-color: transparent;
  height: 100vh;
  width: 100vw;
  position: absolute;
  left: 0;
  // top: 96px;
  padding: 85px 79px 552px 32px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
}

.box_5 {

}
.more-img{
  width: 28px;
  height: 28px;
  background: #EDEDED;
  border-radius: 2px;
  display: flex;
  justify-content: space-around;
  text-align: center;
  flex-direction: column;
  margin: 2px 2px 0 2px;

}
.label-3{
  width: 24px;
  height: 6px!important;
  margin: 2px;
}
.text-wrapper_3 {
  // background-color: rgba(3, 108, 252, 1);
  border-radius: 50%;
  margin-bottom: 10px;
  padding: 5px 10px 5px 10px;
}

.text_11 {
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 18px;
  font-family: PingFangSC-Medium;
  font-weight: 500;
  text-align: center;
  white-space: nowrap;
  line-height: 18px;
}

.text_12 {
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 24px;
  font-family: PingFangSC-Medium;
  font-weight: 500;
  text-align: center;
  white-space: nowrap;
  line-height: 24px;
  margin: 2px 0 0 8px;
}

.label_3 {
  width: 32px;
  height: 36px;
  margin: 2px 0 0 4px;
}

.text_13 {
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 24px;
  font-family: PingFangSC-Medium;
  font-weight: 500;
  text-align: left;
  white-space: nowrap;
  line-height: 24px;
  margin-top: 2px;
}

.box_6 {
  margin: 13px 9px 0 0;
}

.text-wrapper_4 {
  background-color: rgba(3, 108, 252, 1);
  border-radius: 50%;
  padding: 5px 10px 5px 10px;
}

.text_14 {
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 18px;
  font-family: PingFangSC-Medium;
  font-weight: 500;
  text-align: center;
  white-space: nowrap;
  line-height: 18px;
}

.text_15 {
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 24px;
  font-family: PingFangSC-Medium;
  font-weight: 500;
  text-align: left;
  white-space: nowrap;
  line-height: 24px;
  margin: 2px 0 0 8px;
}

.group_4 {
  background-color: rgba(237, 237, 237, 1);
  border-radius: 2px;
  margin-left: 5px;
  padding: 4px 8px 0 8px;
  height: 30px;
}

.image-text_3 {
  width: 150px;
}

.thumbnail_4 {
  width: 20px;
  height: 20px;
}

.text-group_3 {
  overflow-wrap: break-word;
  color: rgba(51, 51, 51, 1);
  font-size: 18px;
  font-family: PingFangSC-Regular;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 18px;
  margin-top: 1px;
}

</style>
